import { render, staticRenderFns } from "./Register-ponto-atendimento.vue?vue&type=template&id=34dc7d26&"
import script from "./Register-ponto-atendimento.vue?vue&type=script&lang=js&"
export * from "./Register-ponto-atendimento.vue?vue&type=script&lang=js&"
import style0 from "./Register-ponto-atendimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports